import React, { Fragment } from "react";

import { MDBModal } from "mdbreact";
import { useState } from "react";
import { useEffect } from "react";
import { formatHumansBs } from "../../helpers/formatHuman";
import url from "../config/Config";
import CartItem from "./CartItem";

export const Cart = ({ modalSidebarCarrito, setModalSidebarCarrito }) => {
    const [carritoLocal, setCarritoLocal] = useState([]);
    const [subTotal, setSubTotal] = useState(0);

    useEffect(() => {
        if (modalSidebarCarrito) {
            const localCarrito =
                JSON.parse(localStorage.getItem("CarritoJucumari")) ?? [];
            setCarritoLocal(localCarrito);
            if (localCarrito.length > 0) {
                let subTotal = localCarrito.reduce(
                    (total, producto) =>
                        total + producto.precio * producto.cantidad,
                    0
                );
                setSubTotal(subTotal);
            }
        }
    }, [modalSidebarCarrito]);
    

    const eliminarItem = (id) => {
        let carrito = carritoLocal.filter(
            (carritoState) => carritoState.idprod !== id
        );
        let subTotal = carrito.reduce(
            (total, producto) => total + producto.precio * producto.cantidad,
            0
        );

        setSubTotal(subTotal);
        setCarritoLocal(carrito);

        localStorage.setItem("CarritoJucumari", JSON.stringify(carrito));
        window.dispatchEvent(new Event("storage"));
    };
    const actualizarCantidad = (product, newCantidad) => {
        const carritoActualizado = carritoLocal.map((localState) =>
            localState.idprod === product.idprod
                ? {
                      ...localState,
                      cantidad: newCantidad,
                  }
                : localState
        );

        let subTotal = carritoActualizado.reduce(
            (total, producto) => total + producto.precio * producto.cantidad,
            0
        );
        setSubTotal(subTotal);
        setCarritoLocal(carritoActualizado);

        localStorage.setItem(
            "CarritoJucumari",
            JSON.stringify(carritoActualizado)
        );
        window.dispatchEvent(new Event("storage"));
    };

    useEffect(() => {
        if (modalSidebarCarrito) {
            document.body.style.overflow = "hidden";
            document.documentElement.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
            document.documentElement.style.overflow = "auto";
        }

        return () => {
            document.body.style.overflow = "auto";
            document.documentElement.style.overflow = "auto";
        };
    }, [modalSidebarCarrito]);

    return (
        <MDBModal
            isOpen={modalSidebarCarrito}
            tabIndex="-1"
            className="fixed right-0 top-0 h-screen w-[100%] lg:h-screen lg:w-96 lg:max-w-full m-0 bg-white shadow-lg"
            toggle={() => {
                setModalSidebarCarrito(!modalSidebarCarrito);
            }}
            contentClassName="h-full lg:h-auto"

        >
            <div className="h-[calc(100vh-40px)] lg:h-screen flex flex-col relative">
                <div className="flex items-center justify-between bg-secondary-personalize px-4 py-2">
                    <div className="flex flex-col items-center">
                        <h2 className="text-lg font-bold text-white uppercase">
                            Mi Carrito
                        </h2>
                        <p className="text-white font-semibold">
                            Tiene {carritoLocal.length}{" "}
                            {carritoLocal.length > 1
                                ? "Items Seleccionados"
                                : "Item Seleccionado"}
                        </p>
                    </div>
                    <span
                        className="cursor-pointer"
                        onClick={() => setModalSidebarCarrito(false)}
                    >
                        <i className="fas fa-times text-lg"></i>
                    </span>
                </div>
                {carritoLocal.length > 0 ? (
                    <>
                        <div className="flex-grow h-12 overflow-y-auto p-4  space-y-1">
                            {carritoLocal.map((item, index) => (
                                <CartItem
                                    key={index}
                                    item={item}
                                    eliminarItem={eliminarItem}
                                    actualizarCantidad={actualizarCantidad}
                                />
                            ))}
                        </div>
                        <div className="w-full  border-t p-4 bg-gray-100">
                            <p className="flex items-center justify-between">
                                <span
                                    className="font-bold text-xl text-tertiary-personalize"
                                >
                                    SubTotal:
                                </span>
                                <span className="font-semibold text-xl">
                                    {formatHumansBs(subTotal)}
                                </span>
                            </p>
                            <p className="flex items-center justify-between">
                                <span
                                    className="font-bold text-xl text-tertiary-personalize"
                                >
                                    Total:
                                </span>
                                <span className="font-semibold text-xl">
                                    {formatHumansBs(subTotal)}
                                </span>
                            </p>

                            <a
                                href={
                                    "/Carrito" +
                                    "?e=".concat(
                                        localStorage.getItem("empresa")
                                    )
                                }
                                className="w-full block my-2 text-white text-center p-2 text-lg font-bold rounded-full hover:no-underline bg-tertiary-personalize"
                            >
                                Ver carrito
                            </a>
                        </div>
                    </>
                ) : (
                    <div className="h-full flex flex-col justify-center items-center">
                        <span><i className="bg-gray-100 p-3 rounded-full block fas fa-shopping-cart text-4xl text-tertiary-personalize"></i></span>
                        <p className=" text-lg font-semibold">
                            Carrito Vacío{" "}
                        </p>
                        
                    
                    </div>
                )}
            </div>
        </MDBModal>
    );
};
